import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "services/api";

export type AdminUsersFilters = Record<string, string | number>;

export const getAdminUsers = createAsyncThunk(
  "/admin/users",

  async (filters: AdminUsersFilters, { rejectWithValue }) => {
    try {
      const response = await apiCall().get("/admin/users", { params: filters });
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);
